import { useEffect, useState } from 'react';

import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField
} from '@mui/material';

const REASONS = [
    'Lenguaje inapropiado',
    'Ataque personal',
    'Contenido sensible',
    'Spam o publicidad',
    'Irrelevante',
    'Información falsa',
    'Datos personales',
    'Otro'
];

const ModerationDialog = ({ busy, onClose, onSave, open, review }) => {
    const [reason, setReason] = useState('Lenguaje inapropiado');
    const [note, setNote] = useState('');
    const restoring = review?.status === 'hidden';

    useEffect(() => {
        if (open) {
            setReason('Lenguaje inapropiado');
            setNote('');
        }
    }, [open]);

    const invalid = !restoring && (
        (reason === 'Otro' && note.trim().length < 2) ||
        note.trim().length > 500
    );

    return (
        <Dialog fullWidth maxWidth="sm" onClose={busy ? undefined : onClose} open={open}>
            <DialogTitle>
                {restoring ? 'Restaurar reseña' : 'Ocultar reseña'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    {restoring ?
                        'La reseña volverá a la tienda y contará nuevamente en la calificación.'
                    :
                        'La reseña dejará de mostrarse y su calificación se ' +
                        'excluirá del producto. Podrás restaurarla después.'}
                </DialogContentText>
                {!restoring &&
                    <>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Motivo</InputLabel>
                            <Select
                                label="Motivo"
                                onChange={({ target }) => setReason(target.value)}
                                value={reason}
                            >
                                {REASONS.map(item =>
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <TextField
                            error={invalid}
                            fullWidth
                            helperText={reason === 'Otro' ?
                                'Describe el motivo. Máximo 500 caracteres.'
                            :
                                'Nota interna opcional. Máximo 500 caracteres.'}
                            inputProps={{ maxLength: 500 }}
                            label="Nota"
                            minRows={3}
                            multiline
                            onChange={({ target }) => setNote(target.value)}
                            value={note}
                        />
                    </>
                }
            </DialogContent>
            <DialogActions>
                <Button disabled={busy} onClick={onClose}>Cancelar</Button>
                <Button
                    disabled={busy || invalid}
                    onClick={() => onSave(restoring ?
                        { action: 'restore' }
                    :
                        { action: 'hide', reason, note: note.trim() }
                    )}
                    variant="contained"
                >
                    {restoring ? 'Restaurar' : 'Ocultar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModerationDialog;
